import React, { FC, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useTranslation } from 'react-i18next'

import SharedCustomHTML from '@optios-frontend-website/shared-ui/src/components/CustomHTML'
import { IHTML, PageSectionTypes } from 'store/page/types'
import Modal from 'shared/Modal'
import Button from 'shared/ButtonModal'
import { useSelector } from 'react-redux'
import { RootState } from 'store/index'
import styled from '@emotion/styled'

type Props = {
  data: IHTML
  updateSection: (name: string, section: PageSectionTypes, position: number, col: number) => void
  position: number
  col: number
  fontColor: string
  isEditing?: boolean
}
//NOG FEEDBACK VRAGEN OP VLAK VAN TYPESCTIPT ETC
const customQuillModul = {
  toolbar: [
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'link'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
  ],
}

const EditorContainer = styled.div`
  margin-bottom: 1em;
  width: 93vw;
  position: relative;
`

const EditorActions = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 1em;
`

const CustomHTML: FC<Props> = (props: Props) => {
  const [value, setValue] = useState(props.data.content)
  const locale = useSelector<RootState, string>((state) => state.config.locale)
  const [isModalOpen, setIsModalOpen] = useState(props.isEditing)
  const [showEditor, setShowEditor] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    setIsModalOpen(props.isEditing)
  }, [props.isEditing])

  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => setShowEditor(true), 100)
      return () => clearTimeout(timer)
    } else {
      setShowEditor(false)
    }
  }, [isModalOpen])

  const onRequestClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setIsModalOpen(false)
  }

  const onSave = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setIsModalOpen(false)

    props.updateSection('html', { content: value }, props.position, props.col)
  }

  const open = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <SharedCustomHTML fontColor={props.fontColor} handleClick={open} data={props.data} />
      {isModalOpen ? (
        <Modal
          isOpen={isModalOpen}
          onSubmit={onSave}
          onRequestClose={onRequestClose}
          title={t('html_part:title_modal', { lng: locale })}
        >
          <EditorContainer>
            {showEditor ? (
              <ReactQuill theme="snow" modules={customQuillModul} value={value} onChange={setValue} />
            ) : null}
            <EditorActions>
              <Button handleClick={onRequestClose} className="dialog-close">
                {t('page:cancel', { lng: locale })}
              </Button>
              <Button type="submit" handleClick={onSave} className="dialog-save">
                {t('page:save', { lng: locale })}
              </Button>
            </EditorActions>
          </EditorContainer>
        </Modal>
      ) : null}
    </>
  )
}

export default CustomHTML
